import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query";
import {
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { toast } from "react-toastify";
import { API_BASE_URL, clientAuthTokenCookieKey } from "../utils/constants";
import { getCookie } from "../utils/helpers";

const customBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  object,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers) => {
      const token = getCookie(clientAuthTokenCookieKey);
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  });

  try {
    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error) {
      if (result.error.status === 401) {
        return result;
      } else if (result.error.status === 403) {
        toast.error("Forbidden - 403");
        return result;
      } else if (result.error.status === 422) {
        // toast.error("Unprocessable entity");
        return result;
      }
    }

    return result;
  } catch (err) {
    console.error("Unexpected error:", err);
    throw err;
  }
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
});
